
<template>
    <el-form label-position="right" label-width="150px" :inline="inline" :class="className">
        <template v-for="i in fDatas">

        <el-form-item :label="i.nickName" v-if="i.type=='Col' && i.colType=='LineCol' && (i.IsShowCheck===undefined ?true: i.IsShowCheck(entity,i) )">
            <template v-for="c in i.colFields" >
                    <el-col :class="c.class" :span="c.span" v-if="c.type=='SplitText'">{{c.nickName}}</el-col>
                    <el-col :span="c.span"  v-else>
                        <formtext-list-item :entity="entity" :field="c" ></formtext-list-item>
                    </el-col>
            </template>
        </el-form-item>

        <template v-else-if="i.type=='JsonFiled' && (i.IsShowCheck===undefined ?true: i.IsShowCheck(entity,i) )">
            <formtext-list :entity="entity[i.JsonFiledName]" :fieldData="i.fieldData"></formtext-list>
        </template>

        <el-form-item :label="i.nickName" v-else-if="i.IsShowCheck===undefined ?true: i.IsShowCheck(entity,i) ">
            <formtext-list-item :entity="entity" :field="i"></formtext-list-item>
        </el-form-item>

        </template>
    </el-form>
</template>
<style>
.el-input__inner{
    height: 35px;
}
.el-select{
    width: 100%;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
}
.ql-toolbar.ql-snow .ql-formats{
    line-height :initial;
}
</style>

<script>

import { ToComponentData, CheckByConfig, ToSubmitData ,$Path,$Urlpath} from '../../config/config.js'
import '../../assets/My97DatePicker/WdatePicker.js'

export default {
    props: ['store','fieldData', 'entity','inline','className'],
    data() {
        return {
        
        }
    },
    created() {
      
    },
    computed: {
        fDatas(){
            return this.store ?this.store.FieldData :  this.fieldData;
        }
       
    },
    mounted () {
       
    },
    methods: {
     
    },
    watch: {
        
    }
}

</script>





// WEBPACK FOOTER //
// formtext_list.vue?4b51f8b2